import React, { useEffect } from 'react';
import clsx from 'clsx';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, withState, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
// import Divider from '@material-ui/core/Divider';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
// import Typography from '@material-ui/core/Typography';
import AppBar from '@material-ui/core/AppBar';
import CssBaseline from '@material-ui/core/CssBaseline';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import MenuIcon from '@material-ui/icons/Menu';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import classNames from 'classnames';
// import { sendLogin } from '../auth/Auth';
import MenuGroupButton from './atoms/MenuGroupButton';
import MenuGroupSmallButton from './atoms/MenuGroupSmallButton';
import { getBookings } from '../actions/Booking';
import { nameSystem } from '../constants/TextSystem';
import { getTextBySystem as gts } from '../utils';
import shopApplyType from '../constants/GochiKidConstant';

const drawerWidth = 240;

const styles = theme => ({
  root: {
    display: 'flex'
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    background: 'none',
    boxShadow: 'none'
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  title: {
    color: '#000',
    fontSize: 24,
    fontWeight: 'bold',
    marginLeft: 24
  },
  menuButton: {
    marginRight: 36,
    color: '#2196F3'
  },
  hide: {
    display: 'none'
  },
  drawer: {
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    backgroundColor: '#D8EBFF'
  },
  drawerOpen: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerClose: {
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    }),
    overflowX: 'hidden',
    backgroundColor: '#D8EBFF',
    width: 84,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing(9) + 1
    }
  },
  drawerOpenCnt: {
    backgroundColor: '#D8EBFF',
    border: 'none',
    overflow: 'hidden',
    boxShadow: '2px 0px 10px 0px rgba(0,0,0,0.3)',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen
    })
  },
  drawerCloseCnt: {
    backgroundColor: '#D8EBFF',
    border: 'none',
    overflow: 'hidden',
    boxShadow: '2px 0px 10px 0px rgba(0,0,0,0.3)',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen
    })
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // padding: theme.spacing(0, 1),
    backgroundColor: theme.palette.primary.main,
    // necessary for content to be below app bar
    ...theme.mixins.toolbar
  },
  toolbarClose: {
    backgroundColor: '#FAFAFA',
    color: '#2196F3'
  },
  btnClose: {
    height: '100%',
    width: '100%',
    position: 'relative',
    paddingRight: 25,
    paddingLeft: 12
  },
  exBtnClose: {
    color: '#2196F3'
  },
  iconBar: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    width: 12,
    backgroundColor: '#ffffff',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: '#2196F3'
  },
  exIconClose: {
    transform: 'rotateY(180deg)',
    position: 'relative',
    left: 15,
    backgroundColor: 'transparent'
  },
  sideBar: {
    backgroundColor: '#D8EBFF',
    padding: 0
  },
  sideBarClose: {
    width: 84
  },
  textMenu: {
    color: '#fff',
    fontSize: 18,
    fontWeight: 'bold',
    whiteSpace: 'break-spaces'
  },
  content: {
    flexGrow: 1,
    padding: theme.spacing(3)
  },
  drawerTitle: {
    padding: 30
  },
  drawerList: {
    padding: 5
  },
  drawerPaper: {
    width: 300
  },
  panelDetails: {
    padding: 5,
    display: 'block'
  },
  termsButton: {
    padding: '6px 16px',
    width: '100%',
    height: '100%',
    fontSize: '1em',
    justifyContent: 'flex-start'
  },
  btHide: {
    background: 'none !important',
    color: '#fff'
  },
  buttonDrawer: {
    display: 'block'
  },
  itemBig: {
    width: '100%',
    display: 'block',
    minWidth: 50
  },
  itemSmall: {
    display: 'block',
    width: '100%'
  },
  listMenu: {
    padding: '15px 10px',
    overflowY: 'auto'
  },
  listMenuItem: {
    padding: 0,
    marginBottom: 6
  },
  menuText: {
    color: '#ffffff',
    textAlign: 'left'
  },
  fs12: {
    fontSize: 12
  },
  txtTransformNone: {
    textTransform: 'none'
  }
});

const enhancer = compose(
  connect(
    state => ({
      listBookings: state.bookings.list.list,
      account: state.accounts.account
    }),
    dispatch => ({
      actions: bindActionCreators(
        {
          getBookings
        },
        dispatch
      )
    })
  ),
  withState('open', 'setOpen', true),
  withState('countBookingNotice', 'setCountBookingNotice', ''),
  withHandlers({
    handleRedirect: props => path => {
      props.history.push(path);
    },
    handleRedirectParams: props => (path, openMenu) => {
      props.history.push({
        pathname: path,
        state: { openMenu }
      });
    }
  }),
  lifecycle({
    componentDidMount() {
      console.log('this.props.location.state', this.props.location.state);
      this.props.setOpen(
        !(
          this.props.location.state &&
          this.props.location.state.openMenu === false
        )
      );
    }
  })
);
const MenuDrawerGroup = enhancer(
  ({
    classes,
    open,
    setOpen,
    handleRedirectParams,
    actions,
    setCountBookingNotice,
    countBookingNotice,
    account
  }) => {
    const isFukuoka =
      typeof account !== 'undefined' && account.fukuokaFlag === 1;
    const educateSystem =
      typeof account !== 'undefined' && account.educateSystem;
    const gochiKidShopApplyType =
      typeof account !== 'undefined' && account.gochiKidShopApplyType;

    useEffect(() => {
      const searchKey = {
        status: 'WAITING'
      };
      if (account.groupDisplayLimit !== 1) {
        actions.getBookings(searchKey).then(data => {
          if (data.type === 'GET_BOOKING_SUCCESS') {
            if (data.payload.list) {
              setCountBookingNotice(data.payload.list.length);
            }
          }
        });
      }
    }, []);

    useEffect(() => {
      const link = document.querySelector("link[rel~='icon']");
      document.title = gts('ごちめし', educateSystem);
      if (isFukuoka && educateSystem === nameSystem.fukuoka) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_fukuoka_icon.png`;
      } else if (isFukuoka && educateSystem === nameSystem.suita) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_suita_icon.ico`;
      } else if (isFukuoka && educateSystem === nameSystem.suita) {
        link.href = `${process.env.PUBLIC_URL}/images/logo_nishiwaki.ico`;
      } else {
        link.href = `favicon.ico`;
      }
    }, [isFukuoka, educateSystem]);

    const theme = useTheme();
    const handleDrawerOpen = () => {
      setOpen(true);
    };
    const handleDrawerClose = () => {
      setOpen(false);
    };
    const openHome = () => {
      handleRedirectParams('/home_group', open);
    };
    const openGochi = () => {
      // handleRedirect('/gochis_group');
      handleRedirectParams('/gochis_group', open);
    };
    const openDeposit = () => {
      handleRedirectParams('/deposit_group', open);
    };
    const openShop = () => {
      handleRedirectParams('/shops_group', open);
    };
    const openBudgetEdit = () => {
      handleRedirectParams('/budget_edit', open);
    };
    const openGochiListGroup = () => {
      handleRedirectParams('/supply_gochi_group', open);
    };
    const openListBookingGroup = () => {
      handleRedirectParams('/list_booking_group', open);
    };
    const openMenu = () => {
      handleRedirectParams('/gochi_menus_group', open);
    };
    const openNotify = () => {
      handleRedirectParams('/notifications_group', open);
    };
    // const openPost = () => {
    //   handleRedirectParams('/posts_group', open);
    // };
    const openRegisStrip = () => {
      handleRedirectParams('/register_stripe_group', open);
    };
    const openSetting = () => {
      handleRedirectParams('/settings_group', open);
    };
    // const openQrCode = () => {
    //   // handleRedirect('/download_qr_shop');
    //   // setOpenShopDownloadQr(true);
    // };
    const openVideoGuide = () => {
      handleRedirectParams('/video_group', open);
    };
    const openPolicy = () => {
      const url = 'https://gochimeshi.com/policy/owner-terms/';
      window.open(url, '_blank');
    };

    const openSummeryReport = () => {
      handleRedirectParams('/summary_report_group', open);
    };

    const openGochiCodeGroup = () => {
      handleRedirectParams('/gochi_code_group', open);
    };

    const openGroupManagement = () => {
      handleRedirectParams('/groups_group', open);
    };

    const openGochiKidMenu = () => {
      handleRedirectParams('/gochi_kid_menus_group', open);
    };
    // const isGroup = typeof account !== 'undefined' && account.role === 'GROUP';
    // if (!isGroup) {
    //   sendLogin(this.props);
    // }
    return (
      <>
        <CssBaseline />
        <AppBar
          position="fixed"
          className={clsx(classes.appBar, {
            [classes.appBarShift]: open
          })}
        >
          <Toolbar>
            <IconButton
              color="inherit"
              aria-label="open drawer"
              onClick={handleDrawerOpen}
              edge="start"
              className={clsx(classes.menuButton, {
                [classes.hide]: open
              })}
            >
              <MenuIcon />
            </IconButton>
          </Toolbar>
        </AppBar>
        <Drawer
          variant="permanent"
          className={classNames(
            clsx(classes.drawer, {
              [classes.drawerOpen]: open,
              [classes.drawerClose]: !open
            }),
            classNames(classes.sideBar, !open ? classes.sideBarClose : '')
          )}
          classes={{
            paper: clsx({
              [classes.drawerOpenCnt]: open,
              [classes.drawerCloseCnt]: !open
            })
          }}
        >
          <div
            className={classNames(
              classes.toolbar,
              !open ? classes.toolbarClose : ''
            )}
          >
            <IconButton
              onClick={handleDrawerClose}
              className={classNames(
                classes.btnClose,
                !open ? classes.exBtnClose : ''
              )}
            >
              {theme.direction === 'rtl' ? (
                <>
                  {open && (
                    <div className={classes.menuText}>
                      <span className={classes.textMenu}>
                        {gts(
                          'GOCHIプラットフォーム管理システム',
                          educateSystem
                        )}
                      </span>
                      <div className={classes.fs12}>Ver 1.18.0</div>
                    </div>
                  )}
                  <span
                    className={classNames(
                      classes.iconBar,
                      !open ? classes.exIconClose : ''
                    )}
                  >
                    <ChevronRightIcon />
                  </span>
                </>
              ) : (
                <>
                  {open && (
                    <div className={classes.menuText}>
                      <span className={classes.textMenu}>
                        {gts(
                          'GOCHIプラットフォーム管理システム',
                          educateSystem
                        )}
                      </span>
                      <div className={classes.fs12}>Ver 1.18.0</div>
                    </div>
                  )}
                  <span
                    className={classNames(
                      classes.iconBar,
                      !open ? classes.exIconClose : ''
                    )}
                  >
                    <ChevronLeftIcon />
                  </span>
                </>
              )}
            </IconButton>
          </div>
          {/* <Divider /> */}
          <List className={classes.listMenu}>
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemBig}>
                <MenuGroupButton
                  open={open}
                  classStyle="icon-home"
                  label="ホーム"
                  onClickAction={openHome}
                  currentRoute="/home_group"
                />
              </ListItemIcon>
            </ListItem>
            {!isFukuoka && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemBig}>
                  <MenuGroupButton
                    open={open}
                    classStyle="icon-file-new"
                    label="グループ店舗管理"
                    onClickAction={openGroupManagement}
                    currentRoute="/groups_group"
                  />
                </ListItemIcon>
              </ListItem>
            )}
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemBig}>
                <MenuGroupButton
                  open={open}
                  classStyle="icon-icon-store"
                  label={isFukuoka ? 'グループ教室一覧' : 'グループ店舗一覧'}
                  onClickAction={openShop}
                  currentRoute="/shops_group"
                />
              </ListItemIcon>
            </ListItem>
            {account.groupType !== 'OTHERS' &&
              !isFukuoka &&
              gochiKidShopApplyType !== shopApplyType.CITY && (
                <ListItem className={classes.listMenuItem}>
                  <ListItemIcon className={classes.itemBig}>
                    <MenuGroupButton
                      open={open}
                      classStyle="icon-gochi-list"
                      label="ごち発行一覧"
                      onClickAction={openGochiListGroup}
                      currentRoute="/supply_gochi_group"
                    />
                  </ListItemIcon>
                </ListItem>
              )}
            {/* {account.groupType !== 'OTHERS' && ( */}
            {account.groupDisplayLimit !== 1 && !isFukuoka && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemBig}>
                  <MenuGroupButton
                    open={open}
                    classStyle="icon-booking"
                    label="お客様からの連絡"
                    numberCount={countBookingNotice}
                    onClickAction={openListBookingGroup}
                    currentRoute="/list_booking_group"
                  />
                </ListItemIcon>
              </ListItem>
            )}
            {/* )} */}
            {account.groupType !== 'OTHERS' &&
              !isFukuoka &&
              gochiKidShopApplyType !== shopApplyType.CITY && (
                <ListItem className={classes.listMenuItem}>
                  <ListItemIcon className={classes.itemBig}>
                    <MenuGroupButton
                      open={open}
                      classStyle="icon-budget"
                      label="予算確認"
                      onClickAction={openBudgetEdit}
                      currentRoute="/budget_edit"
                    />
                  </ListItemIcon>
                </ListItem>
              )}
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemBig}>
                <MenuGroupButton
                  open={open}
                  classStyle="icon-wave"
                  label="サマリーレポート"
                  onClickAction={openSummeryReport}
                  currentRoute="/summary_report_group"
                />
              </ListItemIcon>
            </ListItem>
            {account.groupDisplayLimit !== 1 && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemBig}>
                  <MenuGroupButton
                    open={open}
                    classStyle="icon-icon-payment"
                    label={isFukuoka ? '精算情報管理' : '入金情報管理'}
                    onClickAction={openDeposit}
                    currentRoute="/deposit_group"
                  />
                </ListItemIcon>
              </ListItem>
            )}
            {gochiKidShopApplyType !== shopApplyType.CITY && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemBig}>
                  <MenuGroupButton
                    open={open}
                    classStyle="icon-icon-menu"
                    label={isFukuoka ? 'コース情報' : 'メニュー情報'}
                    onClickAction={openMenu}
                    currentRoute="/gochi_menus_group"
                  />
                </ListItemIcon>
              </ListItem>
            )}
            {!isFukuoka && gochiKidShopApplyType !== shopApplyType.CITY && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemBig}>
                  <MenuGroupButton
                    open={open}
                    classStyle="icon-gochi-kid"
                    label="こどもごちめし"
                    onClickAction={openGochiKidMenu}
                    currentRoute="/gochi_kid_menus_group"
                    disabled={
                      process.env.REACT_APP_SHOW_GOCHI_KID === 'false' ||
                      process.env.REACT_APP_SHOW_GOCHI_KID === undefined
                    }
                  />
                </ListItemIcon>
              </ListItem>
            )}
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemBig}>
                <MenuGroupButton
                  open={open}
                  classStyle="icon-icon-gochi"
                  label={isFukuoka ? 'クーポン情報' : 'ごち情報'}
                  onClickAction={openGochi}
                  currentRoute="/gochis_group"
                />
              </ListItemIcon>
            </ListItem>
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemBig}>
                <MenuGroupButton
                  open={open}
                  classStyle="icon-gochi-list"
                  label={gts('ごちコード消込', educateSystem)}
                  onClickAction={openGochiCodeGroup}
                  currentRoute="/gochi_code_group"
                />
              </ListItemIcon>
            </ListItem>
            {!isFukuoka && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemSmall}>
                  <MenuGroupSmallButton
                    open={open}
                    classStyle="icon-icon-info"
                    label="運営からのお知らせ"
                    onClickAction={openNotify}
                    currentRoute="/notifications_group"
                  />
                </ListItemIcon>
              </ListItem>
            )}
            {/* <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemSmall}>
                <MenuGroupSmallButton
                  open={open}
                  classStyle="icon-icon-file"
                  label="新着記事"
                  onClickAction={openPost}
                  currentRoute="/posts_group"
                />
              </ListItemIcon>
            </ListItem> */}
            {!isFukuoka && (
              <>
                <ListItem className={classes.listMenuItem}>
                  <ListItemIcon className={classes.itemSmall}>
                    <MenuGroupSmallButton
                      open={open}
                      classStyle="icon-question"
                      label="ごちめしの使い方"
                      onClickAction={openVideoGuide}
                      currentRoute="/video_group"
                    />
                  </ListItemIcon>
                </ListItem>
                <ListItem className={classes.listMenuItem}>
                  <ListItemIcon className={classes.itemSmall}>
                    <MenuGroupSmallButton
                      open={open}
                      classStyle="icon-icon-connection"
                      label={`Stripeに\n接続する`}
                      onClickAction={openRegisStrip}
                      currentRoute="/register_stripe_group"
                      className={classes.txtTransformNone}
                    />
                  </ListItemIcon>
                </ListItem>
              </>
            )}
            <ListItem className={classes.listMenuItem}>
              <ListItemIcon className={classes.itemSmall}>
                <MenuGroupSmallButton
                  open={open}
                  classStyle="icon-icon-configuration"
                  label="設定"
                  onClickAction={openSetting}
                  currentRoute="/settings_group"
                />
              </ListItemIcon>
            </ListItem>
            {!isFukuoka && (
              <ListItem className={classes.listMenuItem}>
                <ListItemIcon className={classes.itemSmall}>
                  <MenuGroupSmallButton
                    open={open}
                    classStyle="icon-icon-shop"
                    label="加盟店規約"
                    onClickAction={openPolicy}
                  />
                </ListItemIcon>
              </ListItem>
            )}
          </List>
        </Drawer>
      </>
    );
  }
);

export default withRouter(withStyles(styles)(MenuDrawerGroup));
